/**
 * Registers a global ⌘+Shift+B listener that toggles `debug.showWipBorder`.
 * Mount once near the root of the app tree.
 */
import { useApp } from "@/state";
import { SHORTCUTS } from "@/keyboard/shortcuts";
import { useShortcut } from "@/keyboard/use-shortcut";
export function useWipBorderShortcut() {
    const app = useApp();
    useShortcut(SHORTCUTS.toggleWipBorder, () => app.toggleWipBorder());
}
